/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Microsoft_Calendar_ReadInputs */

const es_tools_microsoft_calendar_read = /** @type {(inputs: Tools_Microsoft_Calendar_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo evento de Microsoft...`)
};

const en_tools_microsoft_calendar_read = /** @type {(inputs: Tools_Microsoft_Calendar_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Microsoft event...`)
};

/**
* | output |
* | --- |
* | "Reading Microsoft event..." |
*
* @param {Tools_Microsoft_Calendar_ReadInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_microsoft_calendar_read = /** @type {((inputs?: Tools_Microsoft_Calendar_ReadInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Microsoft_Calendar_ReadInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_microsoft_calendar_read(inputs)
	return en_tools_microsoft_calendar_read(inputs)
});
export { tools_microsoft_calendar_read as "tools.microsoft_calendar.read" }